import Card from 'components/card'
import I18n from 'i18n-js'
import { StatusType } from 'models/extensions'
import { Live } from 'models/live'
import React from 'react'
import MessagePage from './message-page'

export interface HomePageProps {
  lives: Live[]
  status: StatusType
  navigateToLiveDetailPage: (id: Live['id']) => void
}

export const HomePage = ({
  lives,
  status,
  navigateToLiveDetailPage,
  ...props
}: HomePageProps) => {
  if (status === StatusType.PENDING) {
    return <MessagePage>{I18n.t('home-page.loading')}</MessagePage>
  }

  if (status === StatusType.ERROR) {
    return <MessagePage>{I18n.t('error.unknown')}</MessagePage>
  }

  if (lives.length === 0) {
    return <MessagePage>{I18n.t('home-page.empty')}</MessagePage>
  }
  return (
    <div className="max-w-md mx-auto" {...props}>
      {lives.map((live) => (
        <Card
          key={live.id}
          item={live}
          onPress={() => navigateToLiveDetailPage(live.id)}
        />
      ))}
    </div>
  )
}
